import { gql } from '@apollo/client';

// input: { resourceId, isPublished, name, description?, isFeatured, type }
export const PATCH_RESOURCE_MUTATION = gql`
    mutation patchResource($input: PatchResourceInput!) {
        result: patchResource(input: $input) {
            id 
            name
            tagIds
            description
            isPublished
        }
    }
`;


export const DELETE_RESOURCE_MUTATION = gql`
    mutation deleteResource($input: DeleteResourceInput!) {
        result: deleteResource(input: $input) {
            affectedRows
        }
    }
`;


export const CREATE_RESOURCE_MUTATION = gql`
    mutation createResource($input: CreateResourceInput!) {
        result: createResource(input: $input) {
            id 
            name
            description
            isPublished 
            resourceFiles {
                totalCount
            }
            resourceLocalizations  {
                totalCount
            }
        }
    }
`;